import React from "react";
import "./SharedReportStyles.css";
import "./InfoGeneral.css";
import NFPAlogo from "@/assets/nfpa-logo.png";
import DarphaLogo from "@/assets/darpha_logo.png";

const InformacionGeneral = ({
  seccion,
  reportInfo = {},
  renderCase,
  updateItemResponse,
  fechaReporte,
  onFechaChange,
}) => {
  const capitalizeWords = (str) => {
    if (!str) return "";
    return str
      .toLowerCase()
      .split(/([ .])/g)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join("");
  };

  // Usando valores por defecto para evitar errores
  const {
    tipoMantenimiento = "",
    empresaCliente = "",
    planta = "",
    ubicacion = "",
    inspector = "",
    representantePlanta = "",
    fecha = "",
  } = reportInfo || {};

  // Ordenar los items por orden (si existe)
  const sortedItems =
    seccion && seccion.items
      ? [...seccion.items].sort((a, b) => (a.orden || 0) - (b.orden || 0))
      : [];

  const handleItemChange = (item, value) => {
    if (updateItemResponse) {
      updateItemResponse(
        seccion.idseccionreporte,
        item.id,
        item.idrespuestaitem,
        item.idrespuestabooleana,
        item.idrespuestanumerica,
        item.idrespuestatexto,
        item.idrespuestaimagen,
        value,
      );
    }
  };

  // Renderiza el input apropiado según el tipo de ítem y respuesta
  const renderInput = (item) => {
    if (renderCase === "create") {
      // Manejar diferentes tipos de inputs según idtipoitem e idtiporespuesta
      if (item.idtiporespuesta === 1) {
        // Respuesta booleana
        return (
          <div className="ig-checkbox-container">
            <label>
              <input
                type="checkbox"
                checked={item.respuesta === true}
                onChange={() => handleItemChange(item, true)}
              />{" "}
              Sí
            </label>
            <label>
              <input
                type="checkbox"
                checked={item.respuesta === false}
                onChange={() => handleItemChange(item, false)}
              />{" "}
              No
            </label>
            <label>
              <input
                type="checkbox"
                checked={item.respuesta === null}
                onChange={() => handleItemChange(item, null)}
              />{" "}
              N/A
            </label>
          </div>
        );
      } else if (item.idtiporespuesta === 2) {
        // Respuesta numérica
        return (
          <input
            type="number"
            className="ig-input-report"
            value={item.respuesta || ""}
            onChange={(e) => handleItemChange(item, e.target.value)}
            placeholder="Ingrese un valor numérico"
          />
        );
      } else if (item.idtiporespuesta === 3) {
        // Respuesta texto
        return (
          <input
            type="text"
            className="ig-input-report"
            value={item.respuesta || ""}
            onChange={(e) => handleItemChange(item, e.target.value)}
            placeholder="Ingrese texto"
          />
        );
      } else {
        return <span>{item.respuesta || ""}</span>;
      }
    } else {
      // Para renderCase "view" o "newFormat"
      if (item.idtiporespuesta === 1) {
        // Respuesta booleana
        if (item.respuesta === true) return "Sí";
        if (item.respuesta === false) return "No";
        return "N/A";
      } else {
        // Otros tipos de respuesta
        return item.respuesta !== null ? item.respuesta : "";
      }
    }
  };

  const renderItems = () => {
    if (!sortedItems.length) return null;

    return (
      <>
        {sortedItems.map((item, index) => (
          <p
            key={item.id || index}
            className={renderCase === "create" ? "ig-item-create" : ""}
          >
            <strong>{item.descripcion}:</strong> {renderInput(item)}
          </p>
        ))}
      </>
    );
  };

  return (
    <div
      className={`sr-section ${renderCase === "newFormat" ? "new-format" : ""}`}
    >
      <div className="ig-info-general-header">
        <img src={DarphaLogo} alt="Darpha Logo" className="ig-darpha-logo" />
        <div className="ig-info-general-title">
          <p className="ig-title-darpha">DARPHA FIRE SOLUTIONS</p>
          <p className="ig-subtitle-darpha">
            EMPRESA ESPECIALISTA EN SISTEMAS DE PROTECCIÓN DE INCENDIO
          </p>
        </div>
        <img src={NFPAlogo} alt="NFPA Logo" className="ig-nfpa-logo" />
      </div>
      <p className="ig-tipo-mantenimiento-title">
        {capitalizeWords(tipoMantenimiento)}
      </p>
      <div className="ig-info-general">
        <p>
          <strong>Empresa Cliente:</strong> {capitalizeWords(empresaCliente)}
        </p>
        <p>
          <strong>Planta:</strong> {capitalizeWords(planta)}
        </p>
        <p>
          <strong>Ubicación:</strong> {capitalizeWords(ubicacion)}
        </p>
        <p>
          <strong>Inspector:</strong> {capitalizeWords(inspector)}
        </p>
        <p>
          <strong>Representante de la propiedad:</strong>{" "}
          {capitalizeWords(representantePlanta)}
        </p>
        <p>
          <strong>Fecha:</strong>{" "}
          {renderCase === "create" && onFechaChange ? (
            <input
              type="date"
              className="ig-input-report"
              value={fechaReporte || ""}
              onChange={(e) => onFechaChange(e.target.value)}
            />
          ) : (
            capitalizeWords(fecha)
          )}
        </p>

        {/* Renderizado dinámico de los items de la sección */}
        {renderItems()}
      </div>
    </div>
  );
};

export default InformacionGeneral;
